import script from "./accountApply.vue?vue&type=script&setup=true&lang=js"
export * from "./accountApply.vue?vue&type=script&setup=true&lang=js"

import "./accountApply.vue?vue&type=style&index=0&id=6bd60c99&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd60c99"]])

export default __exports__